import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { p as props, d as defaults } from './componentEl-fcbc301e.js';
import IconCaretRight from './IconCaretRight.js';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNamePropTypes } from './classNames-1ed461aa.js';
import { b as addMarginClasses, m as marginPropTypes, a as addSpacingClasses, p as paddingPropTypes } from './spacing-0f39ba4a.js';
import { B as Button } from './Button-e85764bc.js';

function BreadcrumbItem({
  componentEl: Component,
  children,
  className,
  current,
  margin,
  ...otherProps
}) {
  let cssClasses = ['st_breadcrumbs__item'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addMarginClasses(margin, cssClasses);
  if (current) {
    cssClasses.push('st_breadcrumbs__item--current');
    return /*#__PURE__*/React.createElement(Component, _extends({
      className: cssClasses.join(' ')
    }, otherProps), children);
  }
  return /*#__PURE__*/React.createElement(Button, _extends({
    componentEl: Component,
    className: cssClasses.join(' '),
    tertiary: true
  }, otherProps), children);
}
BreadcrumbItem.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for box, if any */
  margin: marginPropTypes,
  /** whether this is the current breadcrumb item
  and should be rendered as a non-interactive element */
  current: PropTypes.bool
};
BreadcrumbItem.defaultProps = {
  componentEl: defaults,
  className: null,
  margin: null,
  current: false
};

function Breadcrumbs({
  componentEl: Component,
  children,
  className,
  margin,
  padding,
  ...otherProps
}) {
  let cssClasses = ['st_breadcrumbs'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    padding,
    cssClasses
  });
  const itemsJSX = [];
  const total = React.Children.count(children);
  let counter = 0;
  React.Children.forEach(children, child => {
    counter += 1;
    itemsJSX.push(child);
    if (counter !== total) {
      itemsJSX.push( /*#__PURE__*/React.createElement(IconCaretRight, {
        size: "smd",
        key: `icon-${counter}`
      }));
    }
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), itemsJSX);
}
Breadcrumbs.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** padding for component, if any */
  padding: paddingPropTypes
};
Breadcrumbs.defaultProps = {
  componentEl: defaults,
  className: null,
  margin: null,
  padding: null
};
Breadcrumbs.Item = BreadcrumbItem;
Breadcrumbs.Item.displayName = 'Breadcrumbs.Item';

export { Breadcrumbs as B };
